import { render, staticRenderFns } from "./TFProblem.vue?vue&type=template&id=6b6a0b01&scoped=true&"
import script from "./TFProblem.vue?vue&type=script&lang=js&"
export * from "./TFProblem.vue?vue&type=script&lang=js&"
import style0 from "./TFProblem.vue?vue&type=style&index=0&id=6b6a0b01&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6a0b01",
  null
  
)

export default component.exports